export default "__VITE_ASSET__BObdjFKc__"